import { Skeleton } from "@tokenterminal/core/ui/progress/skeleton/Skeleton"
import { twMerge } from "tailwind-merge"

interface Props {
  size?: number | `${number}`
  className?: string
}

export const ProjectLogoSkeleton = ({ size = "40", className }: Props) => (
  <Skeleton
    role="presentation"
    style={{ width: size, height: size }}
    className={twMerge("rounded-full", className)}
  />
)
